module.exports = function getResource(label, vars = []) {
    const resources = {
        paymentErrorTitle: 'Payment Error',
        paymentCancelledTitle: 'Payment Cancelled',
        paymentCancelledMessage: 'Your PayPal payment was cancelled. Please try again or select a different payment method.',
        paymentErrorMessage: 'An error occurred while processing your PayPal payment. Please try again or select a different payment method.',
        okButton: 'OK'
    };

    return resources[label];
};
